import React from 'react';
import Ratio from 'react-ratio';
import { isMobile } from 'react-device-detect';
import images from '../../assets';

import { VerticalSp, HorizontalSp, NorButton, MediaQuery } from '../Common';

import styled from 'styled-components';
import { useTranslation } from 'react-i18next';
import { withStyles, NativeSelect } from '@material-ui/core';
import TableCell from '@material-ui/core/TableCell';
import TableRow from '@material-ui/core/TableRow';
import TableBody from '@material-ui/core/TableBody';
import TableHead from '@material-ui/core/TableHead';

export const TextFieldComp = ({ value, onClick }) => (
  <div
    onClick={onClick}
    style={{
      cursor: 'pointer',
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'space-between',
      height: 40,
      padding: '0px 5px',
      width: '8.3vw',
      minWidth: isMobile ? 100 : 120,
      maxWidth: isMobile ? 120 : 150,
      borderBottom: '1px solid #a0a0a0',
    }}
  >
    <div
      style={{
        fontFamily: 'NSCJKrR',
        fontSize: isMobile ? 14 : 16,
        color: 'black',
        width: '7.2vw',
        minWidth: 90,
        maxWidth: 130,
        textAlign: 'center',
      }}
    >
      {value}
    </div>
    <img alt="" src={images.icon_calendar} style={{ width: isMobile ? 15 : 19 }} />
  </div>
);

export const ModalContents = ({ children, style, onClose }) => {
  return (
    <>
      <div style={{ backgroundColor: 'white', borderRadius: 10, position: 'relative', ...style }} id="receipt">
        <MediaQuery min={500}>
          <div style={{ margin: 0 }}>{children}</div>
          <div onClick={onClose} style={{ position: 'absolute', top: 20, right: 20, cursor: 'pointer' }}>
            <img alt="" src={images.icon_close} />
          </div>
        </MediaQuery>
        <MediaQuery max={499}>
          <div style={{ margin: 0 }}>{children}</div>
          <div onClick={onClose} style={{ position: 'absolute', top: 20, right: 20, cursor: 'pointer' }}>
            <img alt="" src={images.icon_close} />
          </div>
        </MediaQuery>
      </div>
    </>
  );
};

export const CustomHead = withStyles({
  root: {
    borderTop: '1px solid #cccccc',
    borderBottom: '1px solid #cccccc',
    backgroundColor: '#fafafa',
    height: 58,
  },
})(TableHead);

export const CustomBody = withStyles({
  root: {
    borderBottom: '1px solid #cccccc',
  },
})(TableBody);

export const CustomCell = withStyles({
  root: {
    height: 66,
    paddingTop: 0,
    paddingBottom: 0,
  },
})(TableCell);

export const ModalHead = withStyles({
  root: {
    borderTop: '1px solid #dddddd',
    borderBottom: '1px solid #dddddd',
    backgroundColor: '#fafafa',
    height: 38,
  },
})(TableHead);

export const ModalCell = withStyles({
  root: {
    height: 38,
    paddingTop: 0,
    paddingBottom: 0,
    border: 0,
  },
})(TableCell);

export const ModalBody = withStyles({
  root: {
    borderBottom: '1px solid #dddddd',
  },
})(TableBody);

export const CustomeSelect = withStyles({
  select: {
    fontFamily: 'NSCJKrR',
    fontSize: 18,
    borderBottom: 0,
  },
})(NativeSelect);

export const PurTabButton = ({ active, onClick, title, style }) => {
  return (
    <>
      <MediaQuery min={900}>
        <div
          onClick={onClick}
          style={{
            fontFamily: active ? 'NSCJKrB' : 'NSCJKrR',
            fontSize: 20,
            color: active ? '#ff8a06' : '#999999',
            lineHeight: '30px',
            height: 30,
            position: 'relative',
            cursor: 'pointer',
            ...style,
          }}
        >
          {title}
          {active && (
            <div
              style={{
                position: 'absolute',
                width: '100%',
                height: 3,
                backgroundColor: '#ff8a06',
                left: 0,
                bottom: -8,
              }}
            />
          )}
        </div>
      </MediaQuery>
      <MediaQuery max={899}>
        <div
          onClick={onClick}
          style={{
            fontFamily: active ? 'NSCJKrB' : 'NSCJKrR',
            fontSize: 16,
            color: active ? '#ff8a06' : '#999999',
            lineHeight: '24px',
            height: 24,
            position: 'relative',
            cursor: 'pointer',
            ...style,
          }}
        >
          {title}
          {active && (
            <div
              style={{
                position: 'absolute',
                width: '100%',
                height: 2,
                backgroundColor: '#ff8a06',
                left: 0,
                bottom: -4,
              }}
            />
          )}
        </div>
      </MediaQuery>
    </>
  );
};

const OptionBtn = styled.div`
  font-family: 'NSCJKrM';
  font-size: 16px;
  color: white;
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  width: 120px;
  height: 40px;
`;

export const PurOptionButton = ({ active, onClick, title, style }) => {
  return (
    <>
      <OptionBtn onClick={onClick} style={{ backgroundColor: active ? '#ff8a06' : '#cccccc', ...style }}>
        {title}
      </OptionBtn>
    </>
  );
};

export const HeadCell = styled.div`
  font-family: 'NSCJKrR';
  font-size: clamp(0.625rem, 0.3906rem + 0.75vw, 0.8125rem);
  color: black;
  width: 'max-content';
`;

export const BodyCell = styled.div`
  font-family: 'NSCJKrR';
  font-size: 16px;
  color: black;
  display: flex;
  align-items: center;
`;

export const ReceiptBtn = styled.div`
  font-family: 'NSCJKrR';
  font-size: 12px;
  color: black;
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: 5px;
  border: 1px solid #cccccc;
  width: 78px;
  height: 28px;
  cursor: pointer;
`;

export const ReceiptBtnMobile = styled.div`
  font-family: 'NSCJKrR';
  font-size: clamp(0.59375rem, 0.5547rem + 0.125vw, 0.625rem);
  color: black;
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: 5px;
  border: 1px solid #cccccc;
  width: 70px;
  height: 20px;
  cursor: pointer;
`;

export const ReceiptDate = styled.div`
  font-family: 'NSCJKrR';
  font-size: 14px;
  color: black;
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
`;

export const DetailItem = styled.div`
  display: flex;
  align-items: center;
  padding: 10px;
  border-bottom: 1px solid #eeeeee;
`;

export const DItemNo = styled.div`
  font-family: 'NSCJKrR';
  font-size: 16px;
  color: black;
  display: flex;
  align-items: center;
  cursor: pointer;
  width: 108px;
`;

export const DItemTitle = styled.div`
  font-family: 'NSCJKrB';
  font-size: 16px;
  color: black;
`;

export const DItemText = styled.div`
  font-family: 'NSCJKrR';
  font-size: 14px;
  color: black;
  display: flex;
  align-items: center;
`;

export const DItemDot = styled.div`
  width: 4px;
  height: 4px;
  background-color: black;
  border-radius: 10px;
  margin-right: 5px;
`;

export const DItemCost = styled.div`
  font-family: 'NSCJKrB';
  font-size: 16px;
  color: black;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 0px 10px;
`;

export const DItemCostMobile = styled.div`
  font-family: 'NSCJKrB';
  font-size: clamp(0.65625rem, 0.4609rem + 0.625vw, 0.8125rem);
  color: black;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 0px 10px;
  cursor: pointer;
`;

export const DItemDowndload = styled.div`
  font-family: 'NSCJKrB';
  font-size: 14px;
  color: #ff8a06;
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: 30px;
  border: 1px solid #ff8a06;
  width: 98px;
  height: 34px;
`;

export const DItemDowndloadMobile = styled.div`
  font-family: 'NSCJKrB';
  font-size: 12px;
  color: #ff8a06;
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: 30px;
  border: 1px solid #ff8a06;
  width: 70px;
  height: 30px;
  cursor: pointer;
`;

export const DItemConverting = styled.div`
  font-family: 'NSCJKrB';
  font-size: 14px;
  color: #686868;
  background-color: #d9d9d9;
  border: 1px solid #d9d9d9;
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: 30px;
  width: 98px;
  height: 34px;
  cursor: pointer;
`;

export const DItemDowndTxt = styled.div`
  font-family: 'NSCJKrR';
  font-size: 12px;
  color: #666666;
  text-align: center;
`;

export const DItemDesBlock = ({ onDownClick, onReqClick, refundPossible }) => {
  const { t } = useTranslation();
  return (
    <>
      <div
        style={{
          display: 'flex',
          flexDirection: 'column',
          alignItems: 'center',
          justifyContent: 'center',
          borderBottom: '1px solid #eeeeee',
        }}
      >
        <VerticalSp sp={'1.1vw'} style={{ maxHeight: 20, minHeight: 10 }} />
        <MediaQuery min={900}>
          <div style={{ fontFamily: 'NSCJKrR', fontSize: 16, color: 'black', textAlign: 'center' }}>
            {t('order_download_caution_1')}
          </div>
          <div style={{ fontFamily: 'NSCJKrR', fontSize: 16, color: 'black', textAlign: 'center' }}>
            {t('order_download_caution_2')}
          </div>
          <div style={{ fontFamily: 'NSCJKrR', fontSize: 16, color: 'black', textAlign: 'center' }}>
            {t('order_download_caution_3')}
          </div>
        </MediaQuery>
        <MediaQuery max={899}>
          <div style={{ fontFamily: 'NSCJKrR', fontSize: 12, color: 'black', textAlign: 'center' }}>
            {t('order_download_caution_1')}
          </div>
          <div style={{ fontFamily: 'NSCJKrR', fontSize: 12, color: 'black', textAlign: 'center' }}>
            {t('order_download_caution_2')}
          </div>
          <div style={{ fontFamily: 'NSCJKrR', fontSize: 12, color: 'black', textAlign: 'center' }}>
            {t('order_download_caution_3')}
          </div>
        </MediaQuery>
        <VerticalSp sp={'2.8vw'} style={{ maxHeight: 40, minHeight: 20 }} />

        <div style={{ display: 'flex' }}>
          <NorButton
            onClick={onDownClick}
            style={{ fontFamily: 'NSCJKrB', fontSize: 18, width: 200, height: 50, borderRadius: 5 }}
          >
            {t('download_all')}
          </NorButton>
          <HorizontalSp sp={'1.1vw'} style={{ minWidth: 10, maxWidth: 20 }} />
          {refundPossible && (
            <NorButton
              onClick={onReqClick}
              style={{
                fontFamily: 'NSCJKrB',
                fontSize: 18,
                width: 200,
                height: 50,
                backgroundColor: '#222222',
                borderRadius: 5,
              }}
            >
              {t('refund_application')}
            </NorButton>
          )}
          <VerticalSp sp={'4.2vw'} style={{ maxHeight: 76, minHeight: 38 }} />
        </div>
      </div>
    </>
  );
};

export const ReceiptDesItem = ({ label, children }) => {
  return (
    <>
      <div
        style={{
          display: 'flex',
          alignItems: 'center',
          fontFamily: 'NSCJKrR',
          fontSize: 'clamp(0.625rem, 0.4688rem + 0.5vw, 0.75rem)',
          color: 'black',
          lineHeight: '30px',
          height: 30,
          width: isMobile ? '100%' : 'max-content',
        }}
      >
        <div style={{ color: '#999999', width: isMobile ? 95 : 130, marginRight: 8 }}>{label}</div>
        <div style={{ flex: 1, whiteSpace: 'nowrap' }}>{children}</div>
      </div>
    </>
  );
};

export const PdfDownBtn = styled.div`
  font-family: 'NSCJKrM';
  font-size: clamp(0.625rem, 0.5469rem + 0.25vw, 0.6875rem);
  color: black;
  border-radius: 5px;
  border: 1px solid #cccccc;
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;
  width: 100px;
  height: 22px;
  line-height: 12px;
`;

export const ModalHisCell = styled.div`
  font-family: 'NSCJKrR';
  font-size: 14px;
  color: black;
  width: 100%;
`;

export const ModalBlockLbl = styled.div`
  font-family: 'NSCJKrM';
  font-size: 16px;
  color: black;
`;

export const PurMdlTitle = styled.div`
  font-family: 'NSCJKrB';
  font-size: 24px;
  color: black;
  display: flex;
  align-items: center;
  justify-content: center;
  text-align: center;
`;

export const ModalPurTitle = ({ children }) => {
  return (
    <>
      <MediaQuery min={500}>
        <PurMdlTitle>{children}</PurMdlTitle>
      </MediaQuery>
      <MediaQuery max={500}>
        <PurMdlTitle style={{ fontSize: 18 }}>{children}</PurMdlTitle>
      </MediaQuery>
    </>
  );
};

export const BorderBtn = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  font-family: 'NSCJKrR';
  font-size: 14px;
  color: black;
  border-radius: 5px;
  border: 1px solid #cccccc;
  padding: 0px 15px;
  height: 28px;
`;

export class FavDesignThum extends React.Component {
  state = {
    showinfo: false,
  };
  render() {
    const { bg, onFavClick, onBasket, onClick, remove = false, style, license, name, like } = this.props;
    const { showinfo } = this.state;
    return (
      <Ratio
        ratio={1}
        style={{
          ...rootstyle,
          width: '24%',
          minWidth: 160,
          maxWidth: 260,
          backgroundImage: `url(${bg})`,
          backgroundSize: 'cover',
          ...style,
        }}
        onMouseEnter={() => {
          this.setState({ showinfo: true });
        }}
        onMouseLeave={() => {
          this.setState({ showinfo: false });
        }}
      >
        <div
          style={{ position: 'absolute', left: 0, top: 0, width: '100%', height: '100%', zIndex: 9, cursor: 'pointer' }}
          onClick={onClick}
        />
        {/* {isMobile && (
          <div style={{...topstyle, backgroundColor: remove ? 'rgb(255, 138, 6, 0.9)' : 'rgb(0, 0, 0, 0.8)'}}>
            <div style={preminumtext}>{license}</div>
          </div>
        )} */}
        {!isMobile && showinfo && (
          <div style={{ ...topstyle, backgroundColor: remove ? 'rgb(255, 138, 6, 0.9)' : 'rgb(0, 0, 0, 0.8)' }}>
            <div style={preminumtext}>{license}</div>
            <div style={{ ...preminumimg, marginRight: 10 }} onClick={onBasket}>
              <img alt="" src={remove ? images.icon_basket_rmv : images.icon_basket} />
            </div>
            <div style={{ ...preminumimg, marginRight: 16 }} onClick={onFavClick}>
              <img alt="" src={like ? images.icon_liked : images.icon_favori_rmv} />
            </div>
          </div>
        )}
        {!isMobile && showinfo && (
          <div style={{ ...bottomstyle, backgroundColor: remove ? 'rgb(255, 138, 6, 0.9)' : 'rgb(0, 0, 0, 0.8)' }}>
            <div style={bottomtitle}>{name}</div>
            {/* <div style={bottomdesigner}>by Designer</div> */}
          </div>
        )}
      </Ratio>
    );
  }
}

const rootstyle = {
  backgroundSize: 'auto',
  backgroundPosition: 'center',
  marginBottom: '1.5vw',
  position: 'relative',
};

const topstyle = {
  height: 36,
  width: '100%',
  display: 'flex',
  alignItems: 'center',
};

const preminumtext = {
  flex: 1,
  color: 'white',
  fontSize: 14,
  fontFamily: 'NSCJKrM',
  marginLeft: 14,
  lineHeight: '20px',
};

const preminumimg = {
  cursor: 'pointer',
  display: 'flex',
  justifyContent: 'center',
  alignItems: 'center',
  height: 26,
  zIndex: 99,
};

const bottomstyle = {
  width: '100%',
  position: 'absolute',
  bottom: 0,
  left: 0,
  paddingTop: 10,
  paddingBottom: 10,
  cursor: 'pointer',
};

const bottomtitle = {
  fontFamily: 'NSCJKrB',
  color: 'white',
  lineHeight: '14px',
  fontSize: 14,
  marginLeft: 14,
  marginRight: 14,
  marginBottom: 6,
};
